import React from "react";
import { Link } from "react-router-dom";

function Find() {
  return (
    <div className="find-area">
      <div className="container custom-container">
        <div className="row">
          <div className="col-12">
            <form>
              <div className="find-wrap">
                <div className="location">
                  <i className="flaticon-location" />
                  <input type="text" defaultValue="Busca en tu ciudad" />
                </div>
                <div className="find-category">
                  <ul>
                    <li>
                      <div>
                        <i className="flaticon-dog" />
                        Encuentra tu perro
                      </div>
                    </li>
                    <li>
                      <div>
                        <i className="flaticon-happy" /> Tu gatito
                      </div>
                    </li>
                    <li>
                      <div>
                        <i className="flaticon-dove" /> Tu mascota
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="other-find">
                  <li className="other-find-li">
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.galileopethouse.com/",
                          "_blank"
                        )
                      }
                      className="read-more">
                      Visitá la App
                    </div>
                  </li>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Find;
